<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12" sm="12">
      <v-data-table
              no-data-text="Нет отзывов"
              no-results-text="По заданному запросу ничего не найдено"
              :headers="headers"
              :items="reviews"
              v-model="selected"
              :search="search"
              :header-props="{sortIcon: 'icon-custom-arrow'}"
              :options.sync="options"
              :footer-props="footerProps"
              :server-items-length="total"
              :items-per-page="15"
              :loading="loading"
              loading-text="Загрузка отзывов... Подождите пожалуйста"
      >
      </v-data-table>
      <!--</v-card>-->
    </v-col>
  </v-row>
</template>

<script>
    // @ is an alias to /src

    import ReviewService from '../../../api/ReviewService'

    export default {
        name: 'ReviewUserIndex',
        props: {
          value: Object,
        },
        components: {},
      data() {
        return {
          loading: false,
          user: this.value,
          search: '',
          selected: [],
          reviews: [],
          options: {},
          footerProps: {
            itemsPerPageText: 'Отзывов на страницу',
            pageText: '{0}-{1} из {2}',
            itemsPerPageAllText: 'Все',
            itemsPerPageOptions: [15, 30]
          },
          total: 0,
          headers: [
            {
              text: 'Дата / время',
              value: 'created_at'
            },
            {
              text: 'ID заказа',
              sortable: false,
              value: 'order.id',
            },
            {
              text: 'Клиент',
              value: 'user.name',
            },
            {
              text: 'Телефон',
              sortable: false,
              value: 'user.phone',
            },
            {
              text: 'Еда',
              sortable: false,
              value: 'food',
            },
            {
              text: 'Доставка',
              sortable: false,
              value: 'delivery',
            },
            {
              text: 'Сервис',
              sortable: false,
              value: 'pack',
            },
            {
              text: 'Оценка',
              sortable: false,
              value: 'rate',
            },
          ],
        }
      },
        mounted() {
          this.getDataFromApi()
        },
        watch: {
            options: {
                handler() {
                    this.getDataFromApi()
                },
                deep: true,
            },
        },
        methods: {
            getDataFromApi() {
                this.loading = true
              this.selected = [];
                let params = {
                  page: this.options.page,
                  userId: this.user.id,
                  perPage: this.options.itemsPerPage,
                  sortBy: this.options.sortBy.length > 0 ? this.options.sortBy[0] : '',
                  sortDesc: this.options.sortBy.length > 0 ? this.options.sortDesc[0] : '',
                  search: this.search,
                }

                ReviewService.list(params)
                    .then(response => {
                        this.reviews = response.data.data
                        this.total = response.data.total
                        this.loading = false
                    })
            },
        }
    }
</script>

<style>
  .changed-row{
    background-color: #FFEEEC;
  }
</style>

<style lang="scss" scoped>
  .v-btn--fab.v-size--x-small {
    width: 20px;
    height: 20px;

    .mdi::before {
      font-size: 12px;
    }
  }
  span.v-btn{
    border-color: currentColor!important;
  }

  .filter-popup {
    position: absolute;
    width: 250px;
    z-index: 5;

    &:hover {
      cursor: auto;
    }



    &.v-card--link:focus::before {
      opacity: 0;
    }
  }
</style>
